module.exports = __webpack_public_path__ + "img/1.8dc402c0.png";